import React from 'react';

/**
 * Reusable billing interval toggle.
 * Props:
 *  - value: 'month' | 'year'
 *  - onChange: (val) => void
 *  - className: optional wrapper classes
 */
export function BillingIntervalToggle({ value = 'month', onChange, className = '' }) {
  const options = [
    { key: 'month', label: 'Monthly' },
    { key: 'year', label: 'Yearly' },
  ];
  return (
    <div className={`inline-flex items-center rounded-full bg-white/5 border border-white/15 p-1 relative overflow-hidden backdrop-blur-sm ${className}`}>
      {/* Sliding indicator */}
      <div
        className="absolute inset-y-1 w-1/2 rounded-full bg-white text-black shadow transition-transform duration-300 ease-out"
        style={{ transform: value === 'month' ? 'translateX(0%)' : 'translateX(100%)' }}
      />
      {options.map(opt => {
        const active = opt.key === value;
        return (
          <button
            key={opt.key}
            type="button"
            onClick={() => !active && onChange && onChange(opt.key)}
            className={`relative z-10 px-5 py-2 text-sm font-medium transition-colors duration-200 ${active ? 'text-black' : 'text-white/70 hover:text-white'}`}
            aria-pressed={active}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

export default BillingIntervalToggle;